import { render } from "./Menu.vue?vue&type=template&id=38665fb9&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=38665fb9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38665fb9"]])

export default __exports__